<template>
  <div>
    <b-input
      v-model="search"
      placeholder="Search"
      icon-right="close-circle"
      icon-right-clickable
      @icon-right-click="
        () => (($refs.searchInput.newValue = ''), onTableSearch(''))
      "
      @input="(v) => onTableSearch(v)"
      ref="searchInput"
      style="margin-bottom: 5px;"
    ></b-input>

    <b-table
      class="guides-table"
      :data="guides"
      :loading="loading"
      :show-header="false"
      striped
      hoverable
      @click="onTableClick"
    >
      <template slot-scope="props">
        <b-table-column field="title" label="Guides">
          {{ props.row.attributes.title }}
        </b-table-column>
      </template>
      <template slot="empty">
        <div class="content has-text-grey has-text-centered">
          <p>NO RECORDS FOUND</p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { guideMixin } from "@/components/Guide/guideMixin";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  mixins: [guideMixin],
  props: {
    selected: {},
    guideCode: {
      type: String
    }
  },
  data: () => ({
    guidesAll: [],
    guides: [],
    columns: [
      {
        field: "attributes.title",
        label: "Guides"
      }
    ],
    search: "",
    loading: false
  }),
  mounted() {
    this.fetchGuides();
  },
  watch: {
    guideCode() {
      this.reorderGuides();
      this.preselectGuideCode();
    }
  },
  methods: {
    async fetchGuides() {
      try {
        this.loading = true;
        const response = await fetch(
          `${this.fetchBaseUrl}/topics?key=${this.fetchKey}&app_referrer=${location.hostname}&without_steps=1&includes=testResult`
        ).then(response => response.json());
        // let guides = response.data || [];
        let guides = JsonDenormalizer.denormalize(response);
        // Filter guides with code
        this.guidesAll = guides.filter(v => v.attributes.code);
        this.guides = this.guidesAll;
        this.reorderGuides();
        this.preselectGuideCode();
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    },
    reorderGuides() {
      // Re-order guides with current route guides on top and the rest ordered alphabetically
      this.guides = this.guides.sort((a, b) => {
        if (this.guideCode) {
          if (
            a.attributes.code.includes(`${this.guideCode}\/`) &&
            !b.attributes.code.includes(`${this.guideCode}\/`)
          ) {
            return -1;
          }
          if (
            !a.attributes.code.includes(`${this.guideCode}\/`) &&
            b.attributes.code.includes(`${this.guideCode}\/`)
          ) {
            return 1;
          }
        }
        return a.attributes.title.localeCompare(b.attributes.title);
      });
    },
    filterGuides(search) {
      this.guides = this.guidesAll.filter(v => {
        let bool = false;
        let regexp = new RegExp(search, "i"); // case insensitive search
        // Title
        bool = bool ? bool : `${v.attributes.title || ""}`.search(regexp) > -1;
        return bool;
      });
    },
    preselectGuideCode() {
      let guide = null;
      // Pre-select first current route guide
      if (this.guideCode) {
        const routeGuide = this.guides.find(
          v => v.attributes.code.includes(`${this.guideCode}\/`)
        );
        if (routeGuide) guide = routeGuide;
      }
      this.onTableClick(guide);
    },
    onTableSearch: _.debounce(function(v) {
      this.filterGuides(v);
    }, 500),
    onTableClick(row) {
      this.$emit("select", row);
    }
  }
};
</script>

<style>
.guides-table td {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Guide/GuideTable.vue